import { connect } from 'react-redux'
import MapView from './MapView'
import fetchMapData from '../../Handlers/fetchMapData'
import fetchNearbySubcontractors from '../../Handlers/fetchNearbySubcontractors'
import { openProjectCellModal } from '../../State/projectCellModal'

const mapStateToProps = state => ({
  mapData: state.screens.Planner.mapData.data,
  loading: state.screens.Planner.mapData.loading,
  error: state.screens.Planner.mapData.error,
  googleMapsApiKey: (window.env && window.env.GOOGLE_MAPS_API_KEY) || '',
  controls: state.screens.Planner.controls,
  additionalFilter: state.screens.Planner.additionalFilter,
})

const mapDispatchToProps = dispatch => ({
  fetchMapData: () => dispatch(fetchMapData()),
  fetchNearbySubcontractors: (projectId, radius) => dispatch(fetchNearbySubcontractors(projectId, radius)),
  openProjectCellModal: (payload) => dispatch(openProjectCellModal(payload)),
})

export default connect(mapStateToProps, mapDispatchToProps)(MapView)
